module.exports = __webpack_public_path__ + "media/images/roadpass_staggered_logo-7354869f1e338fae415d17d1d46dd2f7.png";